import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Tablet, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const KEY = "passerelle-upsell-hidden-at";
const WEEK = 7 * 86400000;

export function UpsellBanner({ aideName }) {
  const navigate = useNavigate();
  const [hidden, setHidden] = useState(() => Date.now() - Number(localStorage.getItem(KEY) || 0) < WEEK);
  if (hidden) return null;
  const close = () => { localStorage.setItem(KEY, String(Date.now())); setHidden(true); };
  const who = aideName || "votre proche";
  return (
    <section className="relative rounded-3xl bg-white border border-emerald-200 p-6 sm:p-7 mb-8 flex flex-col sm:flex-row gap-5 items-start soft-in" data-testid="family-upsell-banner">
      <button onClick={close} aria-label="Masquer" data-testid="family-upsell-close"
        className="absolute top-3 right-3 w-9 h-9 rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-600 flex items-center justify-center transition-colors">
        <X className="w-4 h-4" />
      </button>
      <span className="shrink-0 w-14 h-14 rounded-2xl bg-emerald-50 text-emerald-700 flex items-center justify-center">
        <Tablet className="w-7 h-7" />
      </span>
      <div className="flex-1 pr-6">
        <p className="text-xs uppercase tracking-[0.25em] font-semibold text-emerald-700">Pour aller un peu plus loin</p>
        <h3 className="font-serif-display text-2xl text-gray-800 mt-1">Un écran tout simple, rien que pour {who}</h3>
        <p className="text-gray-600 mt-2 leading-relaxed">
          Le <strong>mode patient</strong> affiche les jeux en très grand sur la tablette, avec les voix de la famille et les contes lus à voix haute.
          Chaque partie est notée dans son suivi, que vous pouvez télécharger en PDF.
        </p>
        <p className="text-gray-600 mt-2">La formule <strong>Particulier</strong> l'ouvre pour 1 proche : 30&nbsp;€ par semestre.</p>
        <div className="mt-4 flex flex-wrap gap-3">
          <Button onClick={() => navigate("/abonnement")} data-testid="family-upsell-cta">Découvrir la formule Particulier</Button>
          <Button variant="ghost" onClick={close} data-testid="family-upsell-later">Plus tard</Button>
        </div>
      </div>
    </section>
  );
}
